import React from 'react'
import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import PlayerControl from './PlayerControl'

import pic01 from '../images/pic01.jpg'
import pic02 from '../images/pic02.jpg'
import pic03 from '../images/pic03.jpg'

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
  }
  render() {

    let close = <div className="close" onClick={() => {
        this.child.current.pause();
        this.props.onCloseArticle()
      }}></div>

    return (<div id="main" style={this.props.timeout
        ? {
          display: 'flex'
        }
        : {
          display: 'none'
        }}>

      <article id="intro" className={`${this.props.article === 'intro'
          ? 'active'
          : ''} ${this.props.articleTimeout
            ? 'timeout'
            : ''}`} style={{
          display: 'none'
        }}>
        <h2 className="major">Video-React</h2>
        <span className="image main">
          <PlayerControl ref={this.child}/>
        </span>

        {close}
      </article>

      <article id="work" className={`${this.props.article === 'work'
          ? 'active'
          : ''} ${this.props.articleTimeout
            ? 'timeout'
            : ''}`} style={{
          display: 'none'
        }}>
        <h2 className="major">Ed Ward</h2>
        <span className="image main">
          <img src={pic02} alt=""/>
        </span>
        <p>
          Ed Ward is a web developer and software engineer living in Humboldt County on the beautiful and rugged coast of Northern California. I moved to this peaceful, remote location from San Francisco in March of 2016. Simplicity is the ultimate sophistication. This is where the Redwoods meet the Coast and where Poetry meets Code.
        </p>
        {close}
      </article>

      <article id="about" className={`${this.props.article === 'about'
          ? 'active'
          : ''} ${this.props.articleTimeout
            ? 'timeout'
            : ''}`} style={{
          display: 'none'
        }}>
        <h2 className="major">About</h2>
        <span className="image main">
          <img src={pic03} alt=""/>
        </span>
        <p>
          Moons of Saturn is an example of the JAMstack. It is a React app, built with Gatsby, and deployed on Netlify. It also has a simple example of the Video.React component.
        </p>
        <p>
          {' '}
          When we talk about “The Stack,” we no longer talk about operating systems, specific web servers, backend programming languages, or databases.{' '}
        </p>
        <p>
          The JAMstack is not about specific technologies. It’s a new way of building websites and apps that delivers better performance, higher security, lower cost of scaling, and a better developer experience.
        </p>
        {close}
      </article>

      <article id="contact" className={`${this.props.article === 'contact'
          ? 'active'
          : ''} ${this.props.articleTimeout
            ? 'timeout'
            : ''}`} style={{
          display: 'none'
        }}>
        <h2 className="major">Contact</h2>
        <form name="contact" method="post" data-netlify="true" data-netlify-honeypot="bot-field">
          <input type="hidden" name="form-name" value="contact"/>
          <div className="field half first">
            <label htmlFor="name">Name</label>
            <input type="text" name="name" id="name"/>
          </div>
          <div className="field half">
            <label htmlFor="email">Email</label>
            <input type="text" name="email" id="email"/>
          </div>
          <div className="field">
            <label htmlFor="message">Message</label>
            <textarea name="message" id="message" rows="4"/>
          </div>
          <ul className="actions">
            <li>
              <input type="submit" value="Send Message" className="special"/>
            </li>
            <li>
              <input type="reset" value="Reset"/>
            </li>
          </ul>
        </form>
        <ul className="icons">
          <li>
            <a href="https://twitter.com/LostCoastDev" target="_blank" className="icon fa-twitter">
              <span className="label">Twitter</span>
            </a>
          </li>
          <li>
            <a href="https://github.com/lostcoastdev" target="_blank" className="icon fa-github">
              <span className="label">Facebook</span>
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/lostcoastdev/" target="_blank" className="icon fa-linkedin">
              <span className="label">Instagram</span>
            </a>
          </li>
          <li>
            <a href="https://www.streamshoot.com" target="_blank" className="icon fa-play">
              <span className="label">GitHub</span>
            </a>
          </li>
          <li>
            <a href="https://ed-ward-resume.netlify.com/" target="_blank" className="icon fa-bullhorn">
              <span className="label">Resume</span>
            </a>
          </li>
        </ul>
        {close}
      </article>
    </div>)
  }
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js